import { Lock } from 'lucide-react';

import { Card } from '@/components/ui/Card';

/**
 * Shared chrome for the training admin pages. Components only in this
 * module (Vite react-refresh rule) — the access-gate hook lives in
 * `_gate.ts`.
 */

export function TrainingNoAccessCard({ capability }: { capability: string }) {
  return (
    <Card className="mx-auto flex max-w-xl flex-col items-center gap-3 p-12 text-center">
      <Lock className="size-10 text-kw-ghost" />
      <div>
        <p className="text-[15px] font-medium text-kw-shark">Training admin access required</p>
        <p className="mt-1 text-[13px] text-kw-muted">
          You need the <span className="font-mono">{capability}</span> capability for this page. Ask a
          visionary or integrator to grant it.
        </p>
      </div>
    </Card>
  );
}
